<template>
  <v-container>
    <v-form ref="form">
      <v-card flat color="" class="pa-0 mb-3">
        <v-layout row wrap justify-end>
          <v-flex md6 xs12 sm12>
            <v-card flat color="#A5D6A7">
              <v-card-text>
                <span class="headline black--text font-weight-bold"
                  >ปลูกทั้งหมด (ต้น)</span
                >
                <v-flex sm12 xs12 md12 style="text-align:right" class="pb-0">
                  <span
                    class="black--text font-weight-bold"
                    style="color:black !important; font-size:30px;"
                    >{{ commaSeparateNumber(this.summaryPlant) }}
                    <v-progress-circular
                      indeterminate
                      color="white"
                      v-if="loading3"
                    >
                    </v-progress-circular>
                  </span>
                </v-flex>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex md6 xs12 sm12>
            <v-card flat color="#BBDEFB">
              <v-card-text>
                <span class="headline black--text font-weight-bold"
                  >จำนวนผู้ปลูก (คน)</span
                >
                <v-flex sm12 xs12 md12 style="text-align:right" class="pb-0">
                  <div v-if="loading3"></div>
                  <span
                    class="black--text font-weight-bold"
                    style="color:black !important; font-size:30px;"
                    >{{ commaSeparateNumber(this.summaryPeople) }}</span
                  >
                  <v-progress-circular
                    indeterminate
                    color="white"
                    v-if="loading3"
                  >
                  </v-progress-circular>
                </v-flex>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex md12 xs12 sm12 style="text-align:right">
            <span style="font-size:20px"
              >ข้อมูลตั้งแต่ 22 กรกฎาคม 2565 - {{ this.thisTime }}</span
            >
          </v-flex>
        </v-layout>
      </v-card>
      <v-divider class="mt-3 mb-3"></v-divider>
      <v-card flat color="grey lighten-3" class="pa-3">
        <h1>Export</h1>
        <v-layout row wrap justify-end>
          <v-divider class="mt-3 mb-3"></v-divider>
          <v-flex xs12 sm12 md6>
            <v-menu
              v-model="menu"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
              color="blue"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="dateFormattedStart"
                  readonly
                  prepend-inner-icon="event"
                  label="วันเริ่มต้น*"
                  solo
                  hide-details
                  v-on="on"
                  color="blue"
                  :rules="nameRules"
                  @blur="date = parseDate(dateFormattedStart)"
                  required
                  ref="startDate_ref"
                ></v-text-field>
              </template>
              <v-date-picker
                locale="th"
                v-model="startDate"
                no-title
                @input="menu = false"
              ></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs12 sm12 md6>
            <v-menu
              v-model="menu2"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
              color="blue"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="dateFormattedEnd"
                  readonly
                  prepend-inner-icon="event"
                  label="วันสิ้นสุด*"
                  solo
                  hide-details
                  v-on="on"
                  color="blue"
                  :rules="nameRules"
                  @blur="date = parseDate(dateFormattedEnd)"
                  required
                  ref="endDate_ref"
                ></v-text-field>
              </template>
              <v-date-picker
                locale="th"
                v-model="endDate"
                no-title
                @input="menu2 = false"
                :min="startDate"
              ></v-date-picker>
            </v-menu>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12 md12 style="text-align:center">
            <a :href="link !== '' ? link : '#'" style="text-decoration:none">
              <v-btn color="#81D4FA" @click="queryDataOnePageStudentLoan()">
                <v-icon class="mr-1">info</v-icon>
                แสดงข้อมูล
              </v-btn>
            </a>
            <a :href="link !== '' ? link : '#'" style="text-decoration:none">
              <v-btn
                :loading="loading2"
                color="#81C784"
                @click="queryReportStudentLoan()"
              >
                <v-icon class="mr-1">save_alt</v-icon>
                Download Excel
              </v-btn>
            </a>
          </v-flex>
        </v-layout>
      </v-card>
    </v-form>
    <v-divider class="mt-3 mb-3"></v-divider>
    <div v-if="isLoading">
      <v-layout row wrap flex justify-center align-center fill-height>
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </v-layout>
    </div>
    <v-card
      flat
      color="grey lighten-3"
      class="pa-3"
      v-if="listOnePage.length !== 0"
    >
      <v-layout row wrap>
        <v-flex md12 sm12 class="title">
          <span style="font-size:24px"
            >รายงานวันที่ {{ formatDate(startDate) }} ถึง
            {{ formatDate(endDate) }}</span
          >
        </v-flex>
        <v-flex md12 sm12>
          <v-flex md12 sm12>
            <span class="title"> ภาพรวม: </span>
            <br />
            <span style="font-size:24px">
              ต้นไม้ปลูกไปแล้วทั้งหมด
              {{ commaSeparateNumber(listOnePage.userPlantSum) }} ต้น
            </span>
            <span style="font-size:24px">
              จำนวนผู้ปลูก
              {{ commaSeparateNumber(listOnePage.numberofpeople) }} คน
            </span>
          </v-flex>
          <v-divider class="mt-3 mb-3"></v-divider>
        </v-flex>
      </v-layout>
    </v-card>
  </v-container>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      isLoading: false,
      loading2: false,
      loading3: false,
      dateFormattedStart: "",
      dateFormattedEnd: "",
      startDate: "",
      endDate: "",
      menu: false,
      menu2: false,
      headers: [
        {
          text: "user_plant_id",
          align: "left",
          sortable: true,
          value: "user_plant_id"
        },
        { text: "คำนำหน้าชื่อ", align: "left", value: "title" },
        { text: "ชื่อ", value: "name" },
        { text: "นามสกุล", value: "surname" },
        { text: "โทรศัพท์", value: "phone" },
        { text: "ละติจูด", value: "latitude" },
        { text: "ลองจิจูด", value: "longitude" },
        { text: "ชนิดไม้", value: "plant_name" },
        { text: "จำนวน", value: "amount" }
      ],
      listUser: [],
      items: [
        { name: "ชนิดไม้รายคน", value: "user" },
        { name: "ชนิดไม้รายจังหวัด", value: "province" }
      ],
      user_plant_id: "",
      link: "",
      linkCheckPlant: "",
      linkSumPlantByProvince: "",
      nameRules: [(v) => !!v || "Name is required"],
      listOnePage: [],
      thisTime: "",
      summaryPlant: "",
      summaryPeople: ""
    };
  },
  watch: {
    startDate() {
      this.dateFormattedStart = this.formatDate(this.startDate);
    },
    endDate() {
      this.dateFormattedEnd = this.formatDate(this.endDate);
    }
  },
  created() {
    this.loading3 = true;
    this.thisTime = moment()
      .locale("th")
      .add(543, "year")
      .format("LLL");
    this.querySummaryStudentLoan();
  },
  methods: {
    formatDate(date) {
      // console.log(date);
      if (!date) return null;
      const [year, month, day] = date.split("-");
      var year_thai = parseInt(year) + 543;
      return `${day}/${month}/${year_thai}`;
    },
    parseDate(date) {
      if (!date) return null;
      const [day, month, year] = date.split("/");
      var year_2 = parseInt(year) - 543;
      return `${year_2}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    queryReportStudentLoan() {
      this.loading2 = true;
      if (!this.$refs.form.validate()) {
        if (
          !this.$refs.startDate_ref.validate() &&
          !this.$refs.startDate_ref.validate()
        ) {
          this.$swal("กรุณาเลือกวันที่ต้องการ Export ข้อมูล", "", "error");
          return;
        }
        if (!this.$refs.startDate_ref.validate()) {
          this.$swal("กรุณาเลือกวันเริ่มต้น", "", "error");
          return;
        }
        if (!this.$refs.endDate_ref.validate()) {
          this.$swal("กรุณาเลือกวันสิ้นสุด", "", "error");
          return;
        }
      }
      this.loading2 = false;
      this.link =
        process.env.VUE_APP_IPFLASK +
        "/getFileStudentLoan/reportStudentLoan/" +
        this.startDate +
        "_" +
        this.endDate +
        "_" +
        moment().format("H:mm:ss") +
        ".xlsx";

      // this.link = process.env.VUE_APP_IPFLASK + "/getFile/report/" + this.startDate + "_" + this.endDate + ".xlsx";
    },
    querySummaryStudentLoan() {
      this.axios
        .post(process.env.VUE_APP_IPFLASK + "/querySummaryStudentLoan")
        .then((response) => {
          //console.log(response.data);
          this.summaryPlant = response.data.userPlantSum;
          this.summaryPeople = response.data.numberofpeople;
          this.loading3 = false;
        });
    },
    commaSeparateNumber(val) {
      //console.log(val);
      while (/(\d+)(\d{3})/.test(val.toString())) {
        val = val.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
      }
      return val;
    },
    queryDataOnePageStudentLoan() {
      this.isLoading = true;
      this.listOnePage = [];
      if (!this.$refs.form.validate()) {
        if (
          !this.$refs.startDate_ref.validate() &&
          !this.$refs.startDate_ref.validate()
        ) {
          this.$swal("กรุณาเลือกวันที่ต้องการ Export ข้อมูล", "", "error");
          return;
        }
        if (!this.$refs.startDate_ref.validate()) {
          this.$swal("กรุณาเลือกวันเริ่มต้น", "", "error");
          return;
        }
        if (!this.$refs.endDate_ref.validate()) {
          this.$swal("กรุณาเลือกวันสิ้นสุด", "", "error");
          return;
        }
      }

      this.axios
        .post(process.env.VUE_APP_IPFLASK + "/queryDataOnePageStudentLoan", {
          startDate: this.startDate,
          endDate: this.endDate
        })
        .then((response) => {
          // console.log(response.data);
          if (response.data === "no data") {
            this.isLoading = false;
            this.$swal("ไม่พบข้อมูลวันที่ท่านเลือก", "", "error");
          } else {
            this.isLoading = false;
            this.listOnePage = response.data;
            //console.log(this.listOnePage);
          }
        });
    },
    queryInformationUser() {
      if (this.user_plant_id === "") {
        this.$swal("กรุณากรอกรหัส User Plant ID", "", "error");
      } else {
        this.axios
          .post(process.env.VUE_APP_IPFLASK + "/queryInformationUser", {
            user_plant_id: this.user_plant_id
          })
          .then((response) => {
            // console.log(response.data);
            this.listUser = response.data;
            this.user_plant_id = "";
          });
      }
    }
  }
};
</script>
